<div class="Footer flex flex-column gap-4">
  <a class="text-xxs" target="_blank" [routerLink]="'/mentions-legal'">{{'COMMON.footer_static_legal' | translate}}</a>
  <a class="text-xxs" target="_blank" [routerLink]="'/terms-and-conditions'">{{'COMMON.footer_static_terms' | translate}}</a>
  <a class="text-xxs" target="_blank" [routerLink]="'/privacy-policy'">{{'COMMON.footer_static_privacy' | translate}}</a>
  <a class="text-xxs" target="_blank" [routerLink]="'/cookie-policy'">{{'COMMON.footer_static_cookie' | translate}}</a>
  <p class="text-xxs m-0">© GuestUp, {{ fullYear }}.</p>
</div>
